import { Link } from 'react-router-dom';

export default function Dashboard() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white">
      <nav className="border-b border-gray-800 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="text-xl font-bold text-blue-500">
              PumperLens
            </Link>
            <div className="flex gap-4">
              <Link 
                to="/profile"
                className="text-gray-300 hover:text-white px-4 py-2 rounded"
              >
                Profile
              </Link>
              <button className="text-gray-300 hover:text-white px-4 py-2 rounded">
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-3xl font-bold mb-8">Dashboard</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-gray-800 border border-gray-700 rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-4">Welcome to PumperLens</h3>
            <p className="text-gray-300 mb-4">
              Track and analyze Solana tokens with advanced metrics and insights.
            </p>
            <Link 
              to="/"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
            >
              Explore Tokens
            </Link>
          </div>

          <div className="bg-gray-800 border border-gray-700 rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-4">Quick Stats</h3>
            <div className="space-y-2">
              <p className="text-gray-300">Total Tokens Tracked: <span className="text-white font-semibold">1,234</span></p>
              <p className="text-gray-300">Active Users: <span className="text-white font-semibold">5,678</span></p>
              <p className="text-gray-300">Last Updated: <span className="text-white font-semibold">2 minutes ago</span></p>
            </div>
          </div>

          <div className="bg-gray-800 border border-gray-700 rounded-lg p-6">
            <h3 className="text-xl font-semibold mb-4">Recent Activity</h3>
            <div className="space-y-2 text-sm">
              <p className="text-gray-300">• New token added: SOLANA</p>
              <p className="text-gray-300">• Price alert triggered: BONK</p>
              <p className="text-gray-300">• Market cap updated: 1,234 tokens</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 